import { api } from 'app/utils/api/helpers'

export const getAutomationsStats = (teamId: string, params: any) => {
  return api.get(`/sm/team/${teamId}/automations-stats`, { params })
}
